import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.6667 4H5.33334V20H18.6667V4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.9468 19.8195V20.2107H8.55517H7.62987H5.05209V19.8195V7.95912L12.0155 7.95823C12.0156 7.95807 12.0156 7.95807 12.0156 7.95823H12.0155C11.9871 7.99291 7.5618 15.7879 5.78148 18.9239C5.57123 19.2941 5.39787 19.5995 5.273 19.8195H7.62987H8.55517H18.9468ZM11.9815 16.0401H11.9816C11.9815 16.0403 11.9814 16.0403 11.9815 16.0401ZM11.9816 16.0401C12.0162 15.9996 17.5439 6.26167 18.7259 4.17892H15.4437H5.05209V3.78955H16.5368H18.9468V4.17892V16.0401H11.9816Z",
  fill: "black"
})), 'LogoZattini');